function findInShadowRoots(selector) {
  var result = document.querySelector(selector);
  if (result) return result;

  var hosts = document.querySelectorAll('*');
  for (var i = 0; i < hosts.length; i++) {
    if (hosts[i].shadowRoot) {
      result = hosts[i].shadowRoot.querySelector(selector);
      if (result) return result;
    }
  }
  return null;
}

document.querySelectorAll('a.button[href="#chatbot"]').forEach(function (link) {
  link.addEventListener('click', function (e) {
    e.preventDefault();
    var chatBtn = findInShadowRoots('button[data-testid="widgetButtonBody"]');
    if (chatBtn) chatBtn.click();
  });
});
